import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import './App.less';
import Clause from './page/clause';
import GoodsDetail from './page/detail';
import Download from './page/download';

export default class App extends Component {
  render() {
    return <Switch>
      <Route path='/:goodid' exact component={GoodsDetail} />
      <Route path='/download/app' exact component={Download} />
      <Route path='/clause/:type' exact component={Clause} />
    </Switch>
  }
}